import "../assets/css/allArts.css";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import Header from "../component/layout/header";
import Footer from "../component/layout/footer";

const AllArtsPage = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const sortedCategories = [...categories].sort((a, b) =>
    (a.category_name || "")
      .toLowerCase()
      .localeCompare((b.category_name || "").toLowerCase())
  );
  const CategorySkeleton = () => {
  return (
    <div className="all-arts-card skeleton-card">
      <div className="skeleton-img"></div>
      <div className="skeleton-text skeleton-title"></div>
      <div className="skeleton-text skeleton-desc"></div>
      <div className="skeleton-btn"></div>
    </div>
  );
};


  useEffect(() => {
    fetch("https://kalakakshaaha.com/kks/api/admin/arts/categories")
      .then((res) => res.json())
      .then((data) => {
        if (data.success && Array.isArray(data.categories)) {
          const validCategories = data.categories.filter(
            (c) => c.status === 1 && c.category_name?.trim() !== ""
          );
          setCategories(validCategories);
        }
      })
      .catch((err) => console.error("Category fetch error:", err))
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      <Header />

      <section className="arts-section">
        <div className="container">
          <div className="all-arts-container" style={{paddingTop:"170px"}} >

            <h2 className="all-arts-title">All  Categories</h2>

          {loading && (
  <div className="all-arts-grid">
    {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
      <CategorySkeleton key={i} />
    ))}
  </div>
)}


          

            <div className="all-arts-grid">
            {sortedCategories.map((item) => (
                <div className="all-arts-card" key={item.id}>

                  {/* ✅ SAFE IMAGE (NO onError LOOP) */}
                  <img
                    src={
                      item.img_url
                        ? `https://kalakakshaaha.com/uploads/art_categories/${item.img_url}`
                        : "/assets/images/default-category.png"
                    }
                    alt={item.category_name || "Art Category"}
                    className="all-arts-img"
                  />

                  <h3 className="all-arts-heading">
                    {item.category_name}
                  </h3>

                  <p className="all-arts-desc">
                    {item.description || "Explore classes in this category"}
                  </p>

                  <Link
                    to={`/tutors/${encodeURIComponent(item.category_name)}`}
                  >
                    <button className="all-arts-btn">
                      Explore
                    </button>
                  </Link>

                </div>
              ))}
            </div>

          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default AllArtsPage;
